<template>
    <!--    <WebHeader></WebHeader>-->
    <div class="main-page-container"><div class="banner">
        <div class="wrapper">

            <el-carousel  arrow="always" class="el-carousel">
                <!--            <el-carousel indicator-position="outside" arrow="always" style="height: 350px; margin-top: 1rem">-->
                <el-carousel-item
                        v-for="(item, index) in carouselItems"
                        :key="index"
                >
                    <!--                    <img :src="item.image" alt="/img/banner01.jpg" >-->
                    <img  :src="item.image" alt="carousel image" >
                </el-carousel-item>
            </el-carousel>

        </div>
    </div>

    <div class="News">
        <div class="wrapper">
            <div class="content">
                <div class="news" >
                    <div class="service1">
                        <el-icon class="tubiao"><Notification /></el-icon><span > 企业资讯 </span>

                    </div>
                    <el-carousel :interval="4000" class="carouselnews">                        
                        <el-carousel-item v-for="(news, index) in carouselData" :key="index" @click="goToDetail(news)">
                            <img class="carousel-img1" :src="news.backgroundUrl" alt="News Image">
                            <span>{{ news.title }}</span>
                        </el-carousel-item>
                    </el-carousel>
                    <!-- 在这里添加新闻内容 -->
                </div>
                <div class="newstitle">
                    <div class="news-container1">
                        <!-- 新闻标题列表 -->
                        <div class="news-title hover-effect"
							 :class="{ 'active-title': news.isActive }"
							 v-for="(news, index) in newsItems" 
							 :key="news.newsId"
							 @click="goToDetail(news, index)"
						>
							{{ news.title }}
						</div>

						<el-pagination
							@current-change="handleCurrentNewsChange"
							:current-page="currentNewsPage" 
							:page-size="newsPageSize" 
							layout="prev, pager, next"
							:total="total"
							:pager-count="7"
						></el-pagination>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <div class="Video" v-if="paginatedVideos.length > 0">
        <div class="wrapper">
            <div class="content">
                <div class="video">
                    <div class="service1">
                        <el-icon class="tubiao"><VideoCamera /></el-icon><span > 视频号 </span>

                    </div>
                    <div class="video-container">
                        <!-- 显示当前视频 -->
                        <video :src="currentVideo.videoPath" controls style="width: 100%; " v-if="currentVideo"></video>
                    </div>


                </div>
                <div class="videotitle">
                    <div class="video-container1">
                        <div class="video-title hover-effect"
                             :class="{ 'active-title': video.isActive }"
                             v-for="(video, index) in paginatedVideos"
                             :key="video.videoPath"
                             @click="changeVideo(video, index)">
                            <img v-if="index == activeVideoTitleIndex" src="../assets/img1/视频动图.gif" class="active-gif" alt="Active Indicator">
                            {{ video.videoName }}
                        </div>
                        <!-- 分页控件 -->
                        <el-pagination
                                @current-change="handleCurrentVideoChange"
                                :page-size="6"
                                layout="prev, pager, next"
                                :total="videos.length"
                        ></el-pagination>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <div class="show">
        <div class="wrapper">
            <div class="service">
                <el-icon class="tubiao"><Grid /></el-icon><span > 专题服务 </span>
            </div>
			<div id="grid-container" class="grid-container">
				<div 
					v-for="dept in departments" 
					:key="dept.id" 
					:class="['grid-item', dept.iconClass]" 
					@click="$router.push(`/dept/${dept.id}`)"
				>
					<div class="name">{{ dept.name }}</div>
				</div>
			</div>
        </div>
    </div>

    <div class="link">
        <div class="wrapper">
            <div class="demo-image">
                <div class="linkTitle">
                    <el-icon class="tubiao"><Tools /></el-icon><span> 友情链接 </span>
                </div>

                <el-row :gutter="0">
                    <el-col :span="8">
                        <div class="grid-content ep-bg-purple" >
                            <div style="text-align: center; margin: auto">
                                <div class="text-item"  >
                                    <img src="../assets/img1/link1.png"  @click="Handle1">
                                    <!--                            中国中小企业国际合作协会-->
                                </div>
                                <div class="text-item" >
                                    <img src="../assets/img1/link2.png"  @click="Handle2">
                                    <!--                            中国中小企业信息网-->
                                </div>
                                <div class="text-item">
                                    <img src="../assets/img1/link3.png"  @click="Handle3">
                                    <!--                            中国投资指南-->
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="grid-content ep-bg-purple" >
                            <div style="text-align: left; margin: auto">
                                <div class="text-item" >
                                    <img src="../assets/img1/link4.png"  @click="Handle4">
                                    <!--                            中国中小企业国际合作协会-->
                                </div>
                                <div class="text-item" >
                                    <img src="../assets/img1/link6.png"  @click="Handle5">
                                    <!--                            中国中小企业信息网-->
                                </div>
                                <div class="text-item">
                                    <img src="../assets/img1/link7.png"  @click="Handle6">
                                    <!--                            中国投资指南-->
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="grid-content ep-bg-purple" >
                            <div style="text-align: center; margin: auto">
                                <div class="text-item" >
                                    <img src="../assets/img1/link8.png"   @click="Handle7">
                                    <!--                            中国中小企业国际合作协会-->
                                </div>
                                <div class="text-item" >
                                    <img src="../assets/img1/link9.png"   @click="Handle8">
                                    <!--                            中国中小企业信息网-->
                                </div>
                                <div class="text-item">
                                    <img src="../assets/img1/link10.png"  @click="Handle9">
                                    <!--                            中国投资指南-->
                                </div>
                            </div>
                        </div>
                    </el-col>

                </el-row>
            </div>
        </div>
    </div>

    <div class="floating-nav hover-effect">
        <!--
        <a  v-if="isDesktop" @click="$router.push('/backlogin')">会员中心</a>
        <a  @click="$router.push('/RegisterPage')">会员注册</a>
        -->
        <a v-if="false">
            <QRCodeComponent />
        </a>
        <a class="qr-link">
            <div class="qr-wrapper">
              <p>扫一扫关注我们</p>
              <img src="@/assets/img/wechat_qrcode.jpg" alt="公众号二维码" style="width: 100%; height: auto;" />
            </div>
          </a>
    </div></div>

</template>
<script>
    import gif from "@/assets/img1/视频动图.gif";
    import {ref,onMounted} from "vue";
    import axios from 'axios';
    import { reactive } from 'vue';
    import QRCodeComponent from "@/components/QRCodeComponent.vue";
    import request from "@/utils/request";
	import { departments } from '@/config/menuConfig';

    export default {
        name: "MainPage",
        // eslint-disable-next-line
        components: {
            QRCodeComponent
        },
        data(){
            return{
                activeVideoTitleIndex: -1,
                gif: gif,
                companies: [], // 存储公司信息的数组
                form: {},
                contentPreviewDialogVisible: false, // 控制内容预览对话框的显示
                previewContent: '', // 存储要预览的内容
                currentNewsPage: 1, // 新闻当前页码
                currentVideoPage: 1, // 视频当前页码
                newsPageSize: 5, // 新闻每页显示的条目数设置为 4
                videoPageSize: 6, // 视频每页显示的条目数设置为 6
                currentVideo: null, // 当前播放的视频对象
                videos: [], // 存储视频路径和标题的数组
                carouselItems: ref([]),
                isDesktop: true,
                activeVideoIndex: -1, // 用来记录当前激活的视频索引
                activeIndex: -1, // 初始时没有激活的标题
                total: 0,           // aran 关键：存储后端返回的总记录数
                newsItems: [],   // 用于存储从后端获取的新闻数据
                carouselData: [], // aran 轮播图数据（固定为最新5条）
				departments: departments
            }
        },
        computed: {
            // 计算当前页的视频列表
            paginatedVideos() {
                const start = (this.currentVideoPage - 1) * this.videoPageSize;
                const end = this.currentVideoPage * this.videoPageSize;
                return this.videos.slice(start, end);
            },
            // 计算当前页的新闻列表
            //paginatedNewsItems() {
            //    const start = (this.currentNewsPage - 1) * this.newsPageSize;
            //    const end = this.currentNewsPage * this.newsPageSize;
            //    return this.newsItems.slice(start, end);
            //},
            // 最新的新闻条目，用于轮播图
            //latestNewsItems() {
            //    return this.newsItems.slice(0, 5);
            //}
        },
        methods: {
            handleCurrentNewsChange(val) {
                //this.currentNewsPage = currentPage;
                // 1. 更新当前页码 aran
                this.currentNewsPage = val;
                // 2. 重新调接口获取该页的数据 aran
                this.newsPlay();
            },

            selectNews(news, index) {
                this.currentNewsTitle = news.title;
                this.newsItems = this.newsItems.map((n, i) => {
                    n.isActive = i === index;
                return n;
            });
            },
            handleCurrentVideoChange(currentPage) {
                this.currentVideoPage = currentPage; // 更新当前页码
            },
            changeVideo(video,index) {
                this.activeVideoTitleIndex = index;
                const currentIndex = this.videos.indexOf(video);
                this.videos = this.videos.map((v, index) => {
                    if (index === currentIndex) {
                    return reactive({ ...v, isActive: true });
                } else {
                    return reactive({ ...v, isActive: false });
                }
            });
                this.currentVideo = video;
            },

            videoPlay() {
                axios.get('/api/edit_video')
                    .then(response => {
                    if (response.data && response.data.data && response.data.data.records) {
                    const records = response.data.data.records.map(record => ({
                        videoPath: record.videoPath,
                        videoName: record.videoName,
                        id: record.id
                    }));

                    // 根据 id 从大到小排序
                    records.sort((a, b) => b.id - a.id);

                    this.videos = records;
                    this.currentVideo = this.videos[0]; // 设置默认视频为排序后的第一个视频
                } else {
                    console.error('The response data format is not as expected.');
                }
            })
            .catch(error => {
                    console.error('There was an error fetching the video data:', error);
            });
            },


            fetchUserData() {
                axios.get('/api/sys/carouselItem/imagePath')
                    .then(response => {
                    if (response.data && Array.isArray(response.data)) {
                    this.carouselItems = response.data.map(path => ({ image: path }));
                } else {
                    console.error('The response data is not in the expected format.');
                }
            })
            .catch(error => {
                    console.error('There was an error fetching the user data:', error);
            });
            },
            Handle1() {
                //  路径/home对应我在router目录下index.js中定义的path属性值
                window.open("https://xiehui.chinasme.org.cn/", "_blank");
            },
            Handle2() {
                //  路径/home对应我在router目录下index.js中定义的path属性值
                window.open("https://www.sme.com.cn/", "_blank");
            },
            Handle3() {
                //  路径/home对应我在router目录下index.js中定义的path属性值
                window.open("https://fdi.mofcom.gov.cn/", "_blank");
            },
            Handle4() {
                //  路径/home对应我在router目录下index.js中定义的path属性值
                window.open("https://www.miit.gov.cn/", "_blank");
            },
            Handle5() {
                //  路径/home对应我在router目录下index.js中定义的path属性值
                window.open("https://www.sheitc.sh.gov.cn/", "_blank");
            },
            Handle6() {
                //  路径/home对应我在router目录下index.js中定义的path属性值
                window.open("https://stcsm.sh.gov.cn/", "_blank");
            },
            Handle7() {
                //  路径/home对应我在router目录下index.js中定义的path属性值
                window.open("https://www.cnr.cn/", "_blank");
            },
            Handle8() {
                //  路径/home对应我在router目录下index.js中定义的path属性值
                window.open("https://www.xinmin.cn/", "_blank");
            },
            Handle9() {
                //  路径/home对应我在router目录下index.js中定义的path属性值
                window.open("https://www.eastday.com/", "_blank");
            },
            //newsPlay() {
            //    axios.get('/api/edit_news')
            //        .then(response => {
                    // 假设response.data.data.records是一个数组，每个元素都有title和approvalDocuments属性
            //        const allNewsItems = response.data.data.records
            //            .map(record => ({
            //            newsId: record.id,
            //            title: record.title,
            //            backgroundUrl: record.approvalDocuments, // 假设这里是图片地址
            //            content: record.content
            //        }))
            //.sort((a, b) => b.newsId - a.newsId); // 按 id 从大到小排序

            //    this.newsItems = allNewsItems;
            //    this.latestNewsItems = allNewsItems.slice(0, 5); // 只取最新的4条
            //})
            //.catch(error => {
            //        console.error('There was an error fetching the news data:', error);
            //});
            //},
            // ----- aran -----
            newsPlay() {
				axios.get('/api/edit_news', {
					params: {
						pageNum: this.currentNewsPage,
						pageSize: this.newsPageSize
					}
				}).then(res => {
					const data = res.data.data;
					this.newsItems = data.records.map(record => ({
						localId: record.localId, // 统一使用 localId
						title: record.title,
						backgroundUrl: record.approvalDocuments
					}));
					this.total = data.total;

					if (this.currentNewsPage === 1 || this.carouselData.length === 0) {
						this.carouselData = this.newsItems.slice(0, 5);
					}
				})
			},
            // ---------------
            goToDetail(news) {
				// 调试打印，确保能看到具体的 localId
				console.log('正在跳转到详情页，localId:', news.localId);
				
				// 必须确保 params 里的键名 'localId' 与路由配置 path: '/news-detail/:localId' 一致
				this.$router.push({ 
					name: 'NewsDetail', 
					params: { localId: news.localId } 
				});
			}
        },
        created() {
            // this.fetchMienContent();
        },
        mounted() {
            this.newsPlay();
            this.fetchUserData();
            this.videoPlay();
        }

    }
</script>

<style scoped>
/* 直接引入外部 CSS */
@import "@/assets/css/main_combined.css";
</style>

